import { render, staticRenderFns } from "./BlankPaySlipPage.vue?vue&type=template&id=2272b3d6&scoped=true&"
import script from "./BlankPaySlipPage.vue?vue&type=script&lang=js&"
export * from "./BlankPaySlipPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2272b3d6",
  null
  
)

export default component.exports